import React from 'react';
import { EntityFields } from 'app/types/entity';
import { useI18n } from 'app/components/localization';
import { IUser } from 'app/constants/schemas/User';
import { getLanguageById, isLanguageId } from 'app/constants/enums/Language';
import { getTimezoneByName } from 'app/constants/schemas/Timezone';
import { useBrand } from '../OrganizationContext';

export type INewUserDefaults =
  Pick<EntityFields<IUser>, 'language' | 'timezone' | 'brand' | 'marketing_email_consent'>;

export const useNewUserDefaults = (): INewUserDefaults => {
  const { locale, timezone } = useI18n();
  const brand = useBrand();
  if (!isLanguageId(locale)) {
    throw new Error(`Expected locale to be LanguageId: ${locale}`);
  }
  return ({
    language: getLanguageById(locale),
    timezone: getTimezoneByName(timezone),
    brand: brand.id,
    marketing_email_consent: true,
  });
};

/**
 * Render prop that provides default values that should be used when creating a new user profile.
 */
const GetNewUserDefaults: React.FC<{
  children: (defaults: INewUserDefaults) => React.ReactElement,
}> = ({ children }) => {
  const defaults = useNewUserDefaults();
  return children(defaults);
};

export default GetNewUserDefaults;
